const StatusText = {
    statusHeader: {
        english: 'View status',
        spanish: 'Ver estado',
    },
    callForHelp: {
        english: 'Call for help',
        spanish: 'Llama para pedir ayuda',
    }
};
export default StatusText;
